/* Copyright (c) 2018 Scaper */

import { Dispatch } from "redoodle";
import { IGetEstimateRequest, IGetEstimateResponse, IPlace } from "../../functions/src/api/placeInterface";
import { IAppState } from "../app/appState";
import { DELETE_PLACE, SET_PLACE, SET_PLACE_LOADING } from "../app/placeReducer";
import { Logger } from "../utils/logger";
import { FunctionsType } from "./api";
import { executeCallable } from "./service";

export class PlaceService {
    constructor(
        private dispatch: Dispatch,
        private getState: () => IAppState,
        private functions: FunctionsType,
    ) { }

    public getEstimate(place: IPlace) {
        return executeCallable<IGetEstimateRequest, IGetEstimateResponse>(
            this.functions,
            "getEstimate",
            { place },
        );
    }

    public ensurePlaceIsLoaded(placeId: string) {
        const { [placeId]: place } = this.getState().place.places;

        if (place != null) {
            return;
        }

        this.dispatch(SET_PLACE_LOADING.create({ placeId }));
        const geocoder = new google.maps.Geocoder;
        geocoder.geocode({ placeId }, (results, status) => {
            if (status !== google.maps.GeocoderStatus.OK) {
                this.dispatch(DELETE_PLACE.create({ placeId }));
                Logger.error(`Geocoder failed due to: ${status}.`);
                return;
            }

            const place = results[0];
            if (place == null) {
                this.dispatch(DELETE_PLACE.create({ placeId }));
                Logger.error(`Place not found: ${placeId}.`);
            }

            this.dispatch(SET_PLACE.create({ place }));
        });
    }

    public setPlace(place: IPlace) {
        this.dispatch(SET_PLACE.create({ place }));
    }
}
